module.exports = __webpack_public_path__ + "img/mukafaat.33b7342e.png";